type FormatNumberOptions = {
  asCurrency?: boolean; // * If true, format as currency.
  locale?: string; // * Optional locale override.
  currency?: string; // * Optional currency code, e.g., 'USD', 'EUR'.
};

export function formatNumber(
  value: number | string,
  options?: FormatNumberOptions,
): string {
  const numericValue = typeof value === 'string' ? parseFloat(value) : value;

  if (options?.asCurrency) {
    const locale = options.locale || 'en-US';
    const currency = options.currency || 'USD';
    const currencyOptions: Intl.NumberFormatOptions = {
      style: 'currency',
      currency,
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    };

    return new Intl.NumberFormat(locale, currencyOptions).format(numericValue);
  }

  // * Plain number formatting.
  const locale = options?.locale || 'en-US';
  return new Intl.NumberFormat(locale).format(numericValue);
}
